module.exports = __webpack_public_path__ + "static/media/bs5-illustrations.95abb40d.svg";